import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const currencyMap = serverReference.currencies.reduce<{ [key in server.dto.Currencies]: server.dto.Currency }>((acc, curr) => {
  acc[curr.value] = curr;
  return acc;

}, {} as any);

interface Props extends DropdownWithoutOptionsProps<server.dto.Currencies, server.dto.Currencies> {
  focusOnMount?: boolean
}

const CurrencyDropdown = (props: Props) => {
  const selectedCurrency = currencyMap[props.value as server.dto.Currencies];

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.currencies}
    getLabel={(t) => `${t.text} (${t.name})`}
    getValue={(t) => t.value}
    value={selectedCurrency}
    onChange={v => { props.onChange(v.value); }}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      focusOnMount: props.focusOnMount,
      openMenuOnFocus: props.focusOnMount,
      ...props.config
    }}
  />;
};

export default CurrencyDropdown;
